import type { IconProps } from '../../types/icon-props';

export const EmptyItem = (props: IconProps) => {
  const { ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_2017_26159)">
        <path
          d="M36.5311 13.4614C36.5311 9.75759 33.5285 6.755 29.8247 6.755H7.20635C3.50259 6.75477 0.5 9.75736 0.5 13.4611V103.308C0.5 108.796 4.94894 113.244 10.4367 113.244H92.604C97.0346 113.244 100.626 109.653 100.626 105.222V28.1901C100.626 23.7595 97.0346 20.1677 92.604 20.1677H43.2374C39.5334 20.1677 36.5311 17.1651 36.5311 13.4614Z"
          fill="url(#paint0_linear_2017_26159)"
        />
        <path
          d="M96.4464 61.4213H58.5977V35.8776C58.5977 31.8717 61.8449 28.6241 65.8511 28.6241L96.4464 30.5764V61.4213Z"
          fill="url(#paint1_linear_2017_26159)"
        />
        <path
          d="M100.626 105.222V50.5875H0.5V103.308C0.5 108.796 4.94894 113.244 10.4367 113.244H92.604C97.0348 113.245 100.626 109.653 100.626 105.222Z"
          fill="url(#paint2_linear_2017_26159)"
        />
        <path
          d="M92.6045 20.1677H80.7539V113.245H92.6045C97.0351 113.245 100.627 109.653 100.627 105.222V28.1901C100.627 23.7595 97.0351 20.1677 92.6045 20.1677Z"
          fill="url(#paint3_linear_2017_26159)"
        />
        <path
          d="M120.501 105.222C120.501 109.653 116.909 113.245 112.478 113.245H10.4375C15.9255 113.245 20.3742 108.796 20.3742 103.308V42.6627C20.3742 38.2321 23.966 34.6404 28.3966 34.6404H112.478C116.909 34.6404 120.501 38.2321 120.501 42.6627V105.222Z"
          fill="url(#paint4_linear_2017_26159)"
        />
        <path
          d="M32.4514 42.708H29.8874C28.6379 42.708 27.625 43.7209 27.625 44.9704C27.625 46.2198 28.6379 47.2327 29.8874 47.2327H32.4514C33.7008 47.2327 34.7137 46.2198 34.7137 44.9704C34.7137 43.7209 33.7008 42.708 32.4514 42.708ZM65.2448 42.708H40.3843C39.1346 42.708 38.1219 43.7209 38.1219 44.9704C38.1219 46.2198 39.1349 47.2327 40.3843 47.2327H65.2448C66.4942 47.2327 67.5071 46.2198 67.5071 44.9704C67.5071 43.7209 66.4942 42.708 65.2448 42.708ZM56.1652 53.1522C56.1652 51.9028 55.1523 50.8899 53.9029 50.8899H40.3843C39.7843 50.8899 39.2088 51.1282 38.7846 51.5525C38.3603 51.9768 38.1219 52.5522 38.1219 53.1522C38.1219 53.4493 38.1805 53.7435 38.2942 54.018C38.4078 54.2925 38.5745 54.5419 38.7846 54.752C38.9946 54.962 39.244 55.1287 39.5185 55.2424C39.793 55.3561 40.0872 55.4146 40.3843 55.4146H53.9029C54.2 55.4146 54.4942 55.3561 54.7686 55.2424C55.0431 55.1287 55.2925 54.962 55.5026 54.752C55.7127 54.5419 55.8793 54.2925 55.993 54.018C56.1067 53.7435 56.1652 53.4493 56.1652 53.1522ZM65.2038 55.4146C65.5009 55.4146 65.7951 55.3561 66.0696 55.2424C66.3441 55.1287 66.5935 54.962 66.8035 54.752C67.0136 54.5419 67.1803 54.2925 67.294 54.018C67.4077 53.7435 67.4662 53.4493 67.4662 53.1522C67.4662 52.8551 67.4077 52.561 67.294 52.2865C67.1803 52.012 67.0136 51.7626 66.8035 51.5525C66.5935 51.3424 66.3441 51.1758 66.0696 51.0621C65.7951 50.9484 65.5009 50.8899 65.2038 50.8899H60.8118C59.5624 50.8899 58.5495 51.9028 58.5495 53.1522C58.5495 54.4017 59.5624 55.4146 60.8118 55.4146H65.2038Z"
          fill="white"
        />
        <path
          d="M20.3742 65.4103V103.308C20.3742 108.796 15.9253 113.245 10.4375 113.245H112.478C116.909 113.245 120.501 109.653 120.501 105.222V65.4103H20.3742Z"
          fill="url(#paint5_linear_2017_26159)"
        />
        <path
          d="M120.499 105.222V42.6627C120.499 38.2321 116.907 34.6404 112.476 34.6404H78.7734V88.7841L103.234 113.245H112.476C116.907 113.245 120.499 109.653 120.499 105.222Z"
          fill="url(#paint6_linear_2017_26159)"
        />
        <path
          d="M120.502 42.6625V105.222C120.502 109.652 116.911 113.245 112.481 113.245H100.629V34.6414H112.481C116.911 34.6414 120.502 38.2319 120.502 42.6625Z"
          fill="url(#paint7_linear_2017_26159)"
        />
        <path
          d="M112.479 34.6404H28.3974C23.9668 34.6404 20.375 38.2321 20.375 42.6627V65.4103H120.502V42.6627C120.502 38.2321 116.91 34.6404 112.479 34.6404Z"
          fill="url(#paint8_linear_2017_26159)"
        />
        <path
          d="M108.174 89.7533L98.9537 86.0331C97.4576 85.4293 95.7856 85.4293 94.2895 86.0331L85.0695 89.7533C80.973 91.4063 76.5048 88.391 76.5048 83.9736V39.4846C76.5048 33.4867 71.6424 28.6244 65.6445 28.6244H101.638C109.978 28.6244 116.738 35.3849 116.738 43.7244V83.9738C116.738 88.391 112.27 91.4063 108.174 89.7533Z"
          fill="url(#paint9_linear_2017_26159)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2017_26159"
          x1="0.5"
          y1="6.755"
          x2="100.626"
          y2="6.755"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEE45A" />
          <stop offset="1" stop-color="#FEA613" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2017_26159"
          x1="58.5977"
          y1="28.6241"
          x2="96.4464"
          y2="28.6241"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEAEE1" />
          <stop offset="1" stop-color="#FE2AA8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2017_26159"
          x1="0.5"
          y1="50.5875"
          x2="100.626"
          y2="50.5875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2017_26159"
          x1="80.7539"
          y1="20.1677"
          x2="100.627"
          y2="20.1677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2017_26159"
          x1="10.4375"
          y1="34.6404"
          x2="120.501"
          y2="34.6404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEE45A" />
          <stop offset="1" stop-color="#FEA613" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2017_26159"
          x1="10.4375"
          y1="65.4103"
          x2="120.501"
          y2="65.4103"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2017_26159"
          x1="78.7734"
          y1="34.6404"
          x2="120.499"
          y2="34.6404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2017_26159"
          x1="100.629"
          y1="34.6414"
          x2="120.502"
          y2="34.6414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2017_26159"
          x1="69.6228"
          y1="45.6359"
          x2="66.6425"
          y2="15.6752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2017_26159"
          x1="65.6445"
          y1="28.6244"
          x2="116.738"
          y2="28.6244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEAEE1" />
          <stop offset="1" stop-color="#FE2AA8" />
        </linearGradient>
        <clipPath id="clip0_2017_26159">
          <rect width="120" height="120" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

EmptyItem.displayName = 'EmptyItem';
